import { useEffect, useMemo } from "react";
import { BrowserAuthError, InteractionType } from "@azure/msal-browser";
import { useMsalAuthentication } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import { loginRequest } from "@/authConfig";
import { finishLogin, markLoginStarted } from "@/lib/courseLogin";

const isUserCancelled = (error: unknown) =>
  error instanceof BrowserAuthError && error.errorCode === "user_cancelled";

/**
 * Sends the visitor to the Microsoft sign-in screen and lets MSAL bring them
 * back to `returnTo` afterwards. Renders nothing meanwhile. Back from the
 * Microsoft screen shows Impressum instead of starting sign-in again.
 */
export const RedirectLogin = ({ returnTo }: { returnTo: string }) => {
  const request = useMemo(
    () => ({ ...loginRequest, redirectStartPage: returnTo }),
    [returnTo]
  );
  const { error } = useMsalAuthentication(InteractionType.Redirect, request);
  const signInCancelled = isUserCancelled(error);

  const rememberWhereSignInStarted = () => {
    markLoginStarted(returnTo);
  };
  useEffect(rememberWhereSignInStarted, [returnTo]);

  const forgetCancelledSignIn = () => {
    if (!signInCancelled) return;
    finishLogin();
  };
  useEffect(forgetCancelledSignIn, [signInCancelled]);

  if (signInCancelled) return <Navigate to="/impressum" replace />;
  if (error) throw error;
  return null;
};
